import React, { useCallback, useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Modal } from '@/components/Modals';
import { CreateTaskCreationConfigInput, OkrTaskCreationConfig, ProviderType } from '@/types/schema';

import JQLQuery from '../JQLQuery';
import { dialogStyles } from './styles';

const dialogClasses = {
  paper: dialogStyles,
};

interface AddJQLQueryDialogProps {
  inViewJQLQueryDialog: CreateTaskCreationConfigInput | OkrTaskCreationConfig;
  provider: ProviderType;
  onClose: () => void;
  onAddJQLQueryModalSubmit: (searchText: string) => void;
}

function AddJQLQueryDialog(props: AddJQLQueryDialogProps) {
  const { t } = useTranslation();
  const { provider, onClose, inViewJQLQueryDialog, onAddJQLQueryModalSubmit } = props;
  const [searchText, setSearchText] = useState(inViewJQLQueryDialog.searchText);
  const [isQueryValid, setIsQueryValid] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const isUpdatingExistingQuery = !!inViewJQLQueryDialog.searchText;

  const setSearch = useCallback((str: string) => {
    setError(undefined);
    setSearchText(str);
  }, []);

  const onSubmit = useCallback(() => {
    if (!searchText) {
      setError(t('Jira:JQLQueryEmptyError'));

      return;
    }
    if (!isQueryValid) {
      return;
    }

    onAddJQLQueryModalSubmit(searchText);
  }, [isQueryValid, onAddJQLQueryModalSubmit, searchText, t]);

  return (
    <Modal
      open
      action={{
        text: isUpdatingExistingQuery ? t('Common:Actions.Update') : t('Common:Actions.Save'),
        onSubmit,
      }}
      classes={dialogClasses}
      header={{
        title: isUpdatingExistingQuery ? t('Jira:EditJQLQuery') : t('Jira:NewJQLQuery'),
        description: isUpdatingExistingQuery
          ? t('Jira:EditJQLQueryDescription', { providerName: provider.name })
          : t('Jira:NewJQLQueryDescription', { providerName: provider.name }),
      }}
      onClose={onClose}>
      <JQLQuery
        error={error}
        value={searchText}
        onChange={setSearch}
        onSetQueryValid={setIsQueryValid}
      />
    </Modal>
  );
}

export default AddJQLQueryDialog;
